import {routerHandler} from "../../../resources/utils/router";
import {StoreViewComponent} from "../../stores/store-view/store-view.component";
import {StoreViewRoutes} from "../../stores/store-view/store-view.routes";
import {ProjectViewRoutesData} from "./project-view.routes";
import {ProductViewComponent} from "../../products/product-view/product-view.component";
import {ProductViewRoutes} from "../../products/product-view/product-view.routes";
import {UserViewComponent} from "../../users/user-view/user-view.component";
import {UserViewRoutes} from "../../users/user-view/user-view.routes";

export const ProjectViewChildrenRoutesData = routerHandler.injectionChildren(ProjectViewRoutesData, {
  'info': [
    routerHandler.view('store', {
      component: StoreViewComponent, children: StoreViewRoutes, outer: true, prefix: true
    }),
    routerHandler.view('product', {
      component: ProductViewComponent, children: ProductViewRoutes, outer: true, prefix: true
    }),
  ],
  'purchases': [
    routerHandler.view('product', {
      component: ProductViewComponent, children: ProductViewRoutes, outer: true, prefix: true
    }),
    routerHandler.view('store', {
      component: StoreViewComponent, children: StoreViewRoutes, outer: true, prefix: true
    }),
    routerHandler.view('user', {
      component: UserViewComponent, children: UserViewRoutes, outer: true, prefix: true
    }),
  ],
});

export const ProjectViewChildrenRoutes = Object.values(ProjectViewChildrenRoutesData);
